module.exports = __webpack_public_path__ + "static/media/game-background-syntax.2f05f730.jpg";